// extracted by mini-css-extract-plugin
module.exports = {"c-footer":"_84ff5fbbc9--c-footer--2qXXO","c-footer-mobile":"_84ff5fbbc9--c-footer-mobile--1m1V7","c-footer-adaptive":"_84ff5fbbc9--c-footer-adaptive--1zlYb"};